module.exports = __webpack_public_path__ + "officialStatic/img/ptz.d78e845.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/ptz.png
// module id = 0Qyc
// module chunks = 0